import BaseApi from "./base";

export default class ReviewedProductApi extends BaseApi {
  baseName = "reviewed_product";
}
